<template>
  <div>
    <div v-masonry transition-duration="0.3s" item-selector=".item" stagger="0.03s">
      <template v-for="responses in responseArray">
        <div
          v-masonry-tile
          v-for="post in responses"
          :key="post.id"
          class="item lg:w-1/3 sm:w-1/2 w-full p-2"
        >
          <div
            class="card h-full text-0 bg-white"
            v-bind:class="[post.featured_image ? ''  : border]"
          >
            <a :href="actualLink(post)" :title="post.title.rendered" :target="linkTarget(post)" class="plain-text">
              
              <img
                v-if="post.featured_image != false"
                :src="post.featured_image"
                :alt="post.title.rendered"
                class="w-full"
                title="featured-image"
              >

              <div class="p-6 text-base" v-bind:class="[post.featured_image ? '' : hfull]">
                <div
                  class="text-sm font-normal text-black"
                >{{ new Date(post.date).toDateString().replace(/^\S+\s/,'') }}</div>
                <span v-html="post.title.rendered"></span>
                <div class="pt-4" v-html="post.excerpt.rendered"></div>
              </div>
            </a>
          </div>
        </div>
      </template>
    </div>
    <div class="p-4 py-10 text-center antialiased" v-if="this.shown < this.totalPosts">
      <button @click="getMore" class="mg-button mg-button--accent px-6 uppercase">Load More</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card-feed',
  props: {
    type: {
      type: String,
      default: '18'
    },
    taxonomy: {
      type: String,
      default: 'news_types'
    }
  },
  data() {
    return {
      url: '/wp-json/wp/v2/posts',
      filter: '',
      endpoint: '',
      response: [],
      responseArray: [],
      shown: 0,
      page: 1,
      totalPosts: '',
      border: 'border-t-8 border-0 border-secondary border-solid',
      hfull: 'h-full'
    }
  },
  methods: {
    formEndpoint() {
      this.filter = `?${this.taxonomy}=${this.type}&page=${this.page}`
      this.endpoint = `${this.url}${this.filter}`
      this.getResponse()
    },
    getResponse() {
      fetch(this.endpoint)
        .then(response => response.json())
        .then(response => {
          this.responseArray.push(response)
          this.shown += response.length
        })
      this.getTotalPosts()
    },
    getTotalPosts() {
      fetch(this.endpoint).then(
        response => (this.totalPosts = response.headers.get('X-WP-Total'))
      )
    },
    getMore() {
      this.page += 1
      this.formEndpoint()
    },
    actualLink(post) {
      return post.file ? post.file : post.link;
    },
    linkTarget(post) {
      return post.file ? '_blank' : '_self';
    }
  },
  mounted() {
    this.formEndpoint()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/js/components/card-feed.vue